import { useState, useEffect } from "react";

const BackToTop = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  // Back to top button visibility
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!showBackToTop) return null;

  return (
    <>
      <button
        onClick={scrollToTop}
        style={{
          position: "fixed",
          bottom: 30,
          right: 30,
          width: 50,
          height: 50,
          borderRadius: "50%",
          background: "#1a3c6e",
          color: "#fff",
          border: "none",
          cursor: "pointer",
          boxShadow: "0 4px 20px rgba(26, 60, 110, 0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 18,
          fontWeight: 700,
          zIndex: 1000,
          transition: "all 0.3s ease",
          animation: "fadeInUp 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.target.style.background = "#B16116";
          e.target.style.transform = "translateY(-2px)";
          e.target.style.boxShadow = "0 6px 25px rgba(224, 123, 42, 0.4)";
        }}
        onMouseLeave={(e) => {
          e.target.style.background = "#1a3c6e";
          e.target.style.transform = "translateY(0)";
          e.target.style.boxShadow = "0 4px 20px rgba(26, 60, 110, 0.3)";
        }}
        aria-label="Back to top"
      >
        ↑
      </button>

      {/* Back to Top Animation */}
      <style>{`
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </>
  );
};

export default BackToTop;